import React,{useRef, useState, useEffect} from "react";
import { Select, Form, Col, Row } from "react-bootstrap";
import ColorPicker from "../components/ColorPicker";

class DrawOptionsPanel extends React.Component {

	
	constructor(props) {
		super(props);
		
		
		this.props.du.dop = this;
		
		this.optionsPanel = React.createRef();
		
		
		this.state = {
			color: this.props.color,
			thickness: this.props.thickness
		};
		
	}

	async handleChange(e){
		

	};
	handleColorChange = (color) => {
		this.setState({...this.state, color: color });
		if(this.props.onColorChange)
			this.props.onColorChange(color);
	};
	handleThicknessChange = (thickness) => {
		thickness = parseFloat(thickness);
		this.setState({...this.state, thickness: thickness });
		if(this.props.onThicknessChange)
			this.props.onThicknessChange(thickness);
	};

	render() {
		return (
			<div className="drawing-panel d-none" ref={this.optionsPanel} >
				<Row>
					<Col xs="12">
						<b>Line options</b>
					</Col>

					
					<div className="my-3" >
						<Col xs="12 mb-3">
							Thickness <div className="line-example" style={{backgroundColor:this.state.color, height:this.state.thickness+'px', width:'40px'}}></div>
						</Col>
						<Col xs="12">
							<Form.Range min="1" max="5" step="0.1" value={this.state.thickness} onChange={(e)=>{this.handleThicknessChange(e.target.value);}} />
						</Col>
					</div>
					<div className="mb-3">
						<Col xs="12 mb-3">
							Color
						</Col>
						<Col xs="12">
							<ColorPicker onChange={(hex)=>{this.handleColorChange(hex)}} color={this.state.color} />
						</Col>
					</div>

				</Row>
			</div>	
		);
	}
}

export default DrawOptionsPanel;